<div class="container">
  <div class="custo-qualidade-aluno">
    <div class="subtitulo mb-6">
      <div class="flex justify-between">
        <div class="flex flex-col gap-2">
          <p class="text-blue-500 text-heading-lg text-bold">
            Valores do Custo-Aluno Qualidade (CAQ)
          </p>
          <a routerLink="/pqr" class="action text-blue-500 text-heading-sm m-0">
            Conheça os parâmetros de qualidade de refêrencia para essa simulação
          </a>

          <a href="/assets/SIMCAQ_MEMORIA_CALCULO_{{anosReferencias?.anoPqr ?? 2026}}.pdf" target="_blank" class="text-blue-500 text-heading-sm m-0">
            Memória de Cálculo
          </a>
        </div>
        <div class="flex flex-col gap-2">
          <app-menu-suspenso
              (chamadaDeAcao)="chamarAcao($event)" [opcoes]="opcoesFiltroLocalizacao">
           {{ this.filtroLocalizacaoEscolhido.rotulo }}
          </app-menu-suspenso>
        </div>
      </div>
    </div>
  </div>
  <div class="table-content rounded-sm sm-shadow p-4">
    <div class="scroll-container">
      <app-tabela [cabecalhoCustomizado]="true" ngSkipHydration>
        <ng-container cabecalho>
          <tr class="header-row">
            <th class="top-left-header text-body-lg align-start w-32" rowspan="4">Etapa</th>
            <th class="top-header text-body-lg align-start" rowspan="4">
              Área da localidade
            </th>
            <th class="top-header text-body-lg align-start" rowspan="4">Turno</th>
            <th class="top-header text-body-lg align-start" rowspan="4">
              CAQ por mês (R$)
            </th>
            <th class="top-header text-body-lg align-start" rowspan="4">
              Fator de ponderação <sup>(1)</sup>
            </th>
            <th class="top-header text-body-lg align-start" rowspan="4">
              Número de matrículas <sup>(2)</sup>
            </th>
            <th class="top-right-header text-body-lg align-start" rowspan="4" >
              Número de escolas <sup>(3)</sup>
            </th>
          </tr>
          <tr class="boder-none"></tr>
          <tr class="boder-none"></tr>
          <tr class="boder-none"></tr>
        </ng-container>
        <!-- Template reutilizável: 3 linhas (Localidade + Parcial + Integral) -->
        <ng-template
          #linhaCaqTabela
          let-titulo="titulo"
          let-parcial="parcial"
          let-integral="integral"
        >
          <tr class="cells-row">
            <td class="left-cell text-body-lg text-charcoal-600-important align-start" rowspan="3">
              {{ titulo }}
            </td>
          </tr>

          <tr class="cells-row">
            <td class="left-cell text-body-lg text-charcoal-600-important align-start">Parcial</td>
            <td>
              <div class="flex flex-row w-full justify-end gap-4 items-center">
                <div class="relative div-caq-projecao-total-instituicao">
                  <div
                    [style.width.px]="calcularLarguraBarraCAQTabela((parcial?.mediana ?? 0))"
                    class="div-caq-projecao-valor"
                  ></div>
                </div>
                <span class="absolute texto-caq-projecao-valor">
                  {{ (parcial?.mediana ?? 0) | number:'1.0-0' }}
                </span>
              </div>
            </td>
            <td class="text-body-lg text-charcoal-600-important align-center">
              {{ (parcial?.fatorPonderacao ?? 0) | number : '1.2-2' }}
            </td>
            <td class="text-body-lg text-charcoal-600-important align-end">
              {{ (parcial?.numeroMatriculas ?? 0) | number : '1.0-0' }}
            </td>
            <td class="right-cell text-body-lg text-charcoal-600-important align-end">
              {{ (parcial?.numeroEscolas ?? 0) | number : '1.0-0' }}
            </td>
          </tr>

          <tr class="cells-row">
            <td class="left-cell text-body-lg text-charcoal-600-important align-start">Integral</td>
            <td>
              <div class="flex flex-row w-full justify-end gap-4 items-center">
                <div class="relative div-caq-projecao-total-instituicao">
                  <div
                    [style.width.px]="calcularLarguraBarraCAQTabela((integral?.mediana ?? 0))"
                    class="div-caq-projecao-valor-integral"
                  ></div>
                </div>
                <span class="absolute texto-caq-projecao-valor">
                  {{ (integral?.mediana ?? 0) | number:'1.0-0' }}
                </span>
              </div>
            </td>
            <td class="text-body-lg text-charcoal-600-important align-center">
              {{ (integral?.fatorPonderacao ?? 0) | number : '1.2-2' }}
            </td>
            <td class="text-body-lg text-charcoal-600-important align-end">
              {{ (integral?.numeroMatriculas ?? 0) | number }}
            </td>
            <td class="right-cell text-body-lg text-charcoal-600-important align-end">
              {{ (integral?.numeroEscolas ?? 0) | number }}
            </td>
          </tr>
        </ng-template>

        <ng-container corpo *ngIf="dadosRelatorioCaqDto !== undefined">
          <tr class="cells-row">
            <td rowspan="7" class="left-cell text-body-lg text-regular-important text-charcoal-800-important align-start">Creche</td>
          </tr>
          <ng-container *ngIf="filtroLocalizacao === 'URBANO'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Urbana',
                parcial: dadosRelatorioCaqDto.crecheUrbanaParcial,
                integral: dadosRelatorioCaqDto.crecheUrbanaIntegral
              }"
            ></ng-container>
          </ng-container>

          <ng-container *ngIf="filtroLocalizacao === 'NENHUM' ">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Urbana',
                parcial: dadosRelatorioCaqDto.crecheUrbanaIndepLocDiferenciadaParcial,
                integral: dadosRelatorioCaqDto.crecheUrbanaIndepLocDiferenciadaIntegral
              }"
            ></ng-container>
          </ng-container>

          <ng-container *ngIf="filtroLocalizacao === 'NENHUM'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Rural',
                parcial: dadosRelatorioCaqDto.crecheRuralParcial,
                integral: dadosRelatorioCaqDto.crecheRuralIntegral
              }"
            ></ng-container>
          </ng-container>

       <!-- CAMPO -->
          <ng-container *ngIf="filtroLocalizacao === 'CAMPO'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Campo',
                parcial: dadosRelatorioCaqDto.crecheCampoParcial,
                integral: dadosRelatorioCaqDto.crecheCampoIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- TERRA_INDIGENA -->
          <ng-container *ngIf="filtroLocalizacao === 'TERRA_INDIGENA'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Terra indígena',
                parcial: dadosRelatorioCaqDto.crecheTerraIndigenaParcial,
                integral: dadosRelatorioCaqDto.crecheTerraIndigenaIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- QUILOMBOLA -->
          <ng-container *ngIf="filtroLocalizacao === 'QUILOMBOLA'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Quilombola',
                parcial: dadosRelatorioCaqDto.crecheQuilombolaParcial,
                integral: dadosRelatorioCaqDto.crecheQuilombolaIntegral
              }"
            ></ng-container>
          </ng-container>

          <tr class="boder-none"></tr>
          <tr class="boder-none"></tr>
          <tr class="boder-none"></tr>

          <tr class="cells-row">
            <td rowspan="7" class="left-cell text-body-lg text-regular-important text-charcoal-800-important align-start">Pré-Escola</td>
          </tr>
          <!-- Pré-Escola - Urbana -->
          <ng-container *ngIf="filtroLocalizacao === 'URBANO'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Urbana',
                parcial: dadosRelatorioCaqDto.preEscolaUrbanaParcial,
                integral: dadosRelatorioCaqDto.preEscolaUrbanaIntegral
              }"
            ></ng-container>
          </ng-container>

          <ng-container *ngIf="filtroLocalizacao === 'NENHUM'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Urbana',
                parcial: dadosRelatorioCaqDto.preEscolaUrbanaIndepLocDiferenciadaParcial,
                integral: dadosRelatorioCaqDto.preEscolaUrbanaIndepLocDiferenciadaIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- Pré-Escola - Rural (somente quando filtro = NENHUM) -->
          <ng-container *ngIf="filtroLocalizacao === 'NENHUM'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Rural',
                parcial: dadosRelatorioCaqDto.preEscolaRuralParcial,
                integral: dadosRelatorioCaqDto.preEscolaRuralIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- Pré-Escola - Campo -->
          <ng-container *ngIf="filtroLocalizacao === 'CAMPO'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Campo',
                parcial: dadosRelatorioCaqDto.preEscolaCampoParcial,
                integral: dadosRelatorioCaqDto.preEscolaCampoIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- Pré-Escola - Terra Indígena -->
          <ng-container *ngIf="filtroLocalizacao === 'TERRA_INDIGENA'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Terra indígena',
                parcial: dadosRelatorioCaqDto.preEscolaTerraIndigenaParcial,
                integral: dadosRelatorioCaqDto.preEscolaTerraIndigenaIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- Pré-Escola - Quilombola -->
          <ng-container *ngIf="filtroLocalizacao === 'QUILOMBOLA'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Quilombola',
                parcial: dadosRelatorioCaqDto.preEscolaQuilombolaParcial,
                integral: dadosRelatorioCaqDto.preEscolaQuilombolaIntegral
              }"
            ></ng-container>
          </ng-container>

          <tr class="top-left-header"></tr>
          <tr class="top-left-header"></tr>
          <tr class="top-left-header"></tr>

          <tr class="cells-row">
            <td rowspan="7" class="left-cell text-body-lg text-regular-important text-charcoal-800-important align-start">Ensino Fundamental - anos iniciais</td>
          </tr>

          <!-- URBANA: aparece quando filtro = URBANO ou NENHUM -->
          <ng-container *ngIf="filtroLocalizacao === 'URBANO'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Urbana',
                parcial: dadosRelatorioCaqDto.ensFunAnosIniciaisUrbanaParcial,
                integral: dadosRelatorioCaqDto.ensFunAnosIniciaisUrbanaIntegral
              }"
            ></ng-container>
          </ng-container>

          <ng-container *ngIf="filtroLocalizacao === 'NENHUM'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Urbana',
                parcial: dadosRelatorioCaqDto.ensFunAnosIniciaisUrbanaIndepLocDiferenciadaParcial,
                integral: dadosRelatorioCaqDto.ensFunAnosIniciaisUrbanaIndepLocDiferenciadaIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- RURAL: aparece quando filtro = NENHUM -->
          <ng-container *ngIf="filtroLocalizacao === 'NENHUM'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Rural',
                parcial: dadosRelatorioCaqDto.ensFunAnosIniciaisRuralParcial,
                integral: dadosRelatorioCaqDto.ensFunAnosIniciaisRuralIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- CAMPO: aparece quando filtro = CAMPO -->
          <ng-container *ngIf="filtroLocalizacao === 'CAMPO'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Campo',
                parcial: dadosRelatorioCaqDto.ensFunAnosIniciaisCampoParcial,
                integral: dadosRelatorioCaqDto.ensFunAnosIniciaisCampoIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- TERRA INDÍGENA: aparece quando filtro = TERRA_INDIGENA -->
          <ng-container *ngIf="filtroLocalizacao === 'TERRA_INDIGENA'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Terra indígena',
                parcial: dadosRelatorioCaqDto.ensFunAnosIniciaisTerraIndigenaParcial,
                integral: dadosRelatorioCaqDto.ensFunAnosIniciaisTerraIndigenaIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- QUILOMBOLA: aparece quando filtro = QUILOMBOLA -->
          <ng-container *ngIf="filtroLocalizacao === 'QUILOMBOLA'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Quilombola',
                parcial: dadosRelatorioCaqDto.ensFunAnosIniciaisQuilombolaParcial,
                integral: dadosRelatorioCaqDto.ensFunAnosIniciaisQuilombolaIntegral
              }"
            ></ng-container>
          </ng-container>

          <tr class="boder-none"></tr>
          <tr class="boder-none"></tr>
          <tr class="boder-none"></tr>

          <tr class="cells-row">
            <td rowspan="7" class="left-cell text-body-lg text-regular-important text-charcoal-800-important align-start">Ensino Fundamental - anos finais</td>
          </tr>

          <!-- Ens. Fundamental - Anos Finais -->

          <!-- URBANA: aparece quando filtro = URBANO ou NENHUM -->
          <ng-container *ngIf="filtroLocalizacao === 'URBANO'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Urbana',
                parcial: dadosRelatorioCaqDto.ensFunAnosFinaisUrbanaParcial,
                integral: dadosRelatorioCaqDto.ensFunAnosFinaisUrbanaIntegral
              }"
            ></ng-container>
          </ng-container>

          <ng-container *ngIf="filtroLocalizacao === 'NENHUM'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Urbana',
                parcial: dadosRelatorioCaqDto.ensFunAnosFinaisUrbanaIndepLocDiferenciadaParcial,
                integral: dadosRelatorioCaqDto.ensFunAnosFinaisUrbanaIndepLocDiferenciadaIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- RURAL: aparece quando filtro = NENHUM -->
          <ng-container *ngIf="filtroLocalizacao === 'NENHUM'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Rural',
                parcial: dadosRelatorioCaqDto.ensFunAnosFinaisRuralParcial,
                integral: dadosRelatorioCaqDto.ensFunAnosFinaisRuralIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- CAMPO: aparece quando filtro = CAMPO -->
          <ng-container *ngIf="filtroLocalizacao === 'CAMPO'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Campo',
                parcial: dadosRelatorioCaqDto.ensFunAnosFinaisCampoParcial,
                integral: dadosRelatorioCaqDto.ensFunAnosFinaisCampoIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- TERRA INDÍGENA: aparece quando filtro = TERRA_INDIGENA -->
          <ng-container *ngIf="filtroLocalizacao === 'TERRA_INDIGENA'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Terra indígena',
                parcial: dadosRelatorioCaqDto.ensFunAnosFinaisTerraIndigenaParcial,
                integral: dadosRelatorioCaqDto.ensFunAnosFinaisTerraIndigenaIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- QUILOMBOLA: aparece quando filtro = QUILOMBOLA -->
          <ng-container *ngIf="filtroLocalizacao === 'QUILOMBOLA'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Quilombola',
                parcial: dadosRelatorioCaqDto.ensFunAnosFinaisQuilombolaParcial,
                integral: dadosRelatorioCaqDto.ensFunAnosFinaisQuilombolaIntegral
              }"
            ></ng-container>
          </ng-container>


          <tr class="boder-none"></tr>
          <tr class="boder-none"></tr>
          <tr class="boder-none"></tr>

          <tr class="cells-row">
            <td rowspan="7" class="left-cell text-body-lg text-regular-important text-charcoal-800-important align-start">Ensino Médio</td>
          </tr>
           <!-- Ensino Médio -->

          <!-- URBANA: aparece quando filtro = URBANO ou NENHUM -->
          <ng-container *ngIf="filtroLocalizacao === 'URBANO'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Urbana',
                parcial: dadosRelatorioCaqDto.ensMedioUrbanaParcial,
                integral: dadosRelatorioCaqDto.ensMedioUrbanaIntegral
              }"
            ></ng-container>
          </ng-container>

          <ng-container *ngIf="filtroLocalizacao === 'NENHUM'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Urbana',
                parcial: dadosRelatorioCaqDto.ensMedioUrbanaIndepLocDiferenciadaParcial,
                integral: dadosRelatorioCaqDto.ensMedioUrbanaIndepLocDiferenciadaIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- RURAL: aparece quando filtro = NENHUM -->
          <ng-container *ngIf="filtroLocalizacao === 'NENHUM'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Rural',
                parcial: dadosRelatorioCaqDto.ensMedioRuralParcial,
                integral: dadosRelatorioCaqDto.ensMedioRuralIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- CAMPO: aparece quando filtro = CAMPO -->
          <ng-container *ngIf="filtroLocalizacao === 'CAMPO'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Campo',
                parcial: dadosRelatorioCaqDto.ensMedioCampoParcial,
                integral: dadosRelatorioCaqDto.ensMedioCampoIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- TERRA INDÍGENA: aparece quando filtro = TERRA_INDIGENA -->
          <ng-container *ngIf="filtroLocalizacao === 'TERRA_INDIGENA'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Terra indígena',
                parcial: dadosRelatorioCaqDto.ensMedioTerraIndigenaParcial,
                integral: dadosRelatorioCaqDto.ensMedioTerraIndigenaIntegral
              }"
            ></ng-container>
          </ng-container>

          <!-- QUILOMBOLA: aparece quando filtro = QUILOMBOLA -->
          <ng-container *ngIf="filtroLocalizacao === 'QUILOMBOLA'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Quilombola',
                parcial: dadosRelatorioCaqDto.ensMedioQuilombolaParcial,
                integral: dadosRelatorioCaqDto.ensMedioQuilombolaIntegral
              }"
            ></ng-container>
          </ng-container>

          <tr class="boder-none"></tr>
          <tr class="boder-none"></tr>
          <tr class="boder-none"></tr>
          <tr class="cells-row">
            <td rowspan="7" class="left-cell text-body-lg text-regular-important text-charcoal-800-important align-start">EJA</td>
          </tr>

          <ng-container *ngIf="filtroLocalizacao === 'URBANO'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Urbana',
                parcial: dadosRelatorioCaqDto.ejaUrbanaParcial,
                integral: null
              }"
            ></ng-container>
          </ng-container>

          <ng-container *ngIf="filtroLocalizacao === 'NENHUM'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Urbana',
                parcial: dadosRelatorioCaqDto.ejaUrbanaIndepLocDiferenciadaParcial,
                integral: null
              }"
            ></ng-container>
          </ng-container>

          <ng-container *ngIf="filtroLocalizacao === 'NENHUM'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Rural',
                parcial: dadosRelatorioCaqDto.ejaRuralParcial,
                integral: null
              }"
            ></ng-container>
          </ng-container>

          <ng-container *ngIf="filtroLocalizacao === 'CAMPO'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Campo',
                parcial: dadosRelatorioCaqDto.ejaCampoParcial,
                integral: null
              }"
            ></ng-container>
          </ng-container>

          <ng-container *ngIf="filtroLocalizacao === 'TERRA_INDIGENA'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Terra indígena',
                parcial: dadosRelatorioCaqDto.ejaTerraIndigenaParcial,
                integral: null
              }"
            ></ng-container>
          </ng-container>

          <ng-container *ngIf="filtroLocalizacao === 'QUILOMBOLA'">
            <ng-container
              [ngTemplateOutlet]="linhaCaqTabela"
              [ngTemplateOutletContext]="{
                titulo: 'Quilombola',
                parcial: dadosRelatorioCaqDto.ejaQuilombolaParcial,
                integral: null
              }"
            ></ng-container>
          </ng-container>

          <tr class="boder-none"></tr>
          <tr class="boder-none"></tr>
          <tr class="boder-none"></tr>
          <tr class="boder-none"></tr>
          <tr class="boder-none"></tr>
          <tr class="boder-none"></tr>

          <tr class="bold boder-none">
            <td class="align-start" colspan="5" style="border-left: none; border-bottom: none;">TOTAL</td>
            <td class="align-end" style="border-bottom: none;">{{ numeroTotalDeMatriculas | number}}</td>
          </tr>
        </ng-container>
      </app-tabela>
    </div>
    <div class="pt-4">
      <p class="text-body-xs text-charcoal-800 m-0">Notas:</p>
          <p class="text-body-xs text-charcoal-800 m-0">
            <sup>(1)</sup>
            Fator de ponderação = [valor do CAQ de cada etapa/modalidade, turno e área de localização]
        / [CAQ dos anos iniciais do ensino fundamental parcial urbano]. Indica as diferenças de
        custos entre os contextos de oferta (etapas/modalidades, turnos e áreas de localização) na
        forma de número índice (que permite a análise em termos relativos ou percentuais).
          </p>
          <p class="text-body-xs text-charcoal-800 m-0">
            <sup>(2)</sup>
            O número de matrículas é calculado a partir dos microdados do Censo Escolar/INEP com base nas
        etapas e modalidade de educação de jovens e adultos consideradas como prioritárias para as redes
        estaduais e municipais. Na rede estadual, são contabilizadas as matrículas de ensino fundamental
        (anos iniciais e finais), ensino médio e Educação de Jovens e Adultos (EJA) de ensino fundamental
        e médio. Na rede municipal, são incluídas as matrículas de creche, pré-escola, ensino fundamental
        (anos iniciais e finais) e EJA de ensino fundamental.
          </p>
          <p class="text-body-xs text-charcoal-800 m-0">
            <sup>(3)</sup>
            Número de escolas estaduais e municipais, em funcionamento, que ofertam matrícula nas etapas/modalidades prioritárias por turno (parcial e integral), calculado a partir dos microdados do Censo Escolar de {{anosReferencias?.anoCenso ?? 2025}}.
          </p>
    </div>
  </div>
</div>
